module.exports = __webpack_public_path__ + "img/jh-2024.1a34f51f.jpg";